module.exports = __webpack_public_path__ + "static/media/SVG_menu_message.bb54a778.svg";